import React from 'react';
import { ListItemText, Grid } from '@material-ui/core';
import { reminder } from '../../../model/reminder';
import { ToggleButton } from '@material-ui/lab';
import { Check } from '../../../ui-components/Icons';
import moment from 'moment';

export const ReminderInfo = (props: { reminder: reminder, classes: any, showContactInfo: boolean, setSelected: (value: any) => void, clickItem: (_id: string) => void }) => {
    const { reminder } = props;
    let name = reminder.userId;
    if (reminder.nome != null || reminder.cognome != null)
        name = `${reminder.nome} ${reminder.cognome}`;
    let email = `${reminder.email}`;
    // if (reminder.notes)
    let text = `${reminder.notes}`;
    let expiresOn = '';
    let days = 0;
    // console.log("--------------------------------------------------------------------");
    // console.log(reminder.expiresOn);
    // console.log(m.toDateString);
    if (reminder.expiresOn) {
        var m = moment(reminder.expiresOn);
        expiresOn = m.toDate().toLocaleDateString();
        let today = moment();
        days = m.diff(today, 'days') // 1
        // expiresOn = `${reminder?.expiresOn?.toLocaleDateString()}`;
    }

    return <Grid container style={!props.showContactInfo ? { width: 450 } : {}}>
        <Grid item xs={11}
            onClick={() => props.clickItem(reminder._id)} className={props.classes.reminder}>
            {props.showContactInfo ?
                <Grid item xs={4}>
                    <ListItemText primary={name} secondary={(email === null ? 'no email' : email)} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
                </Grid>
                : <></>
            }
            <Grid item xs={props.showContactInfo ? 8 : 12}>
                <ListItemText primary={expiresOn} secondary={text} primaryTypographyProps={{ noWrap: false, variant: 'body1', style: { display: 'block' } }} />
            </Grid>
            {/* <Grid item xs={4}>
                <ListItemText primary={expiresOn} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { float: 'left', display: 'block' } }} />
            </Grid> */}
        </Grid>
        <Grid item xs={1}>
            <ToggleButton value="check" className={days < 1 ? props.classes.checkedred : (days < 5 ? props.classes.checkedorange : props.classes.checkedorangelt)}
                selected={reminder.done}
                onChange={() => { props.setSelected(!reminder.done); }}>
                <Check />
            </ToggleButton>
        </Grid>
    </Grid>
}